import React, { Component } from 'react';
import { Link } from "react-router-dom";
import UserDropdown from "./UserDropdown";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import track from "../lib/tracking";

class Header extends Component {

  render() {

    return (
      <div className="header header--home" >
        <div className="header__links">
          <a href="https://www.gruvi.tv/how-we-work" target="_blank" onClick={() => track("change_eurofilm_page",{page: "gruvi"})}>About Gruvi</a>
          <Link to="/contact-us" onClick={() => track("change_eurofilm_page",{page: "contact"})} >Contact Us</Link>
          {this.props.authed ? <UserDropdown logout={this.props.logout}/>: <Link className="home__log" to="/login" onClick={() => this.props.setRedirect(window.location.pathname)}><FontAwesomeIcon icon="user-lock" /></Link>}
        </div>
        <div className="home__title">
          <img src="/eurofilmlaunches_logo.svg" />
        </div>
        <div className="home__description">
          This site gives distributors a centralised location to track upcoming film releases across the whole of Europe. They can easily see where & when their theatrical titles will be/have been released elsewhere, to encourage the sharing common information, data and marketing assets.
        </div>
      </div>
    );

  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/HomeHeader.js